/**
 * Serializes asynchronous sections: each dispatched function runs only after the previous one has
 * settled, turning overlapping async calls into an ordered queue.
 *
 * Adapted from https://spin.atomicobject.com/2018/09/10/javascript-concurrency/
 */
export class Lock {
    private mutex = Promise.resolve();

    lock(): Promise<() => void> {
        let begin: (unlock: () => void) => void = () => undefined;

        this.mutex = this.mutex.then(() => new Promise(begin));

        return new Promise(res => {
            begin = res;
        });
    }

    async dispatch<T>(fn: (() => Promise<T>) | (() => T)): Promise<T> {
        const unlock = await this.lock();
        try {
            return await fn();
        } finally {
            unlock();
        }
    }
}
